"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = Heading;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Typography = require("../Typography/Typography");

var _excluded = ["className", "children", "testId", "element"];
var styles = {
  "Heading": "Heading__Heading___83D3K"
};

function Heading(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-heading' : _ref$testId,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'h1' : _ref$element,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles['Heading'], className);
  var Element = element; // eslint-disable-line @typescript-eslint/no-non-null-assertion

  return /*#__PURE__*/_react["default"].createElement(_Typography.TypographyContext.Consumer, null, function (value) {
    return /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({
      className: (0, _classnames["default"])(classNames, [value['heading'] && "f36-margin-bottom--".concat(value['heading']['spacing'])]),
      "data-test-id": testId
    }, otherProps), children);
  });
}